/**
 * Generates a URL-friendly slug from a company name + short random suffix.
 * Example: "Acme Corporation" -> "acme-corporation-x7k2"
 * Example: "" (empty) -> "retreat-x7k2"
 *
 * The random suffix ensures uniqueness even if two budgets share the same company name.
 */

const RANDOM_CHARS = 'abcdefghijkmnpqrstuvwxyz23456789'; // no confusing chars (0/o, 1/l)
const SUFFIX_LENGTH = 4;

/**
 * Generate a short random string (e.g. "x7k2")
 */
const randomSuffix = () => {
    let result = '';
    for (let i = 0; i < SUFFIX_LENGTH; i++) {
        result += RANDOM_CHARS.charAt(Math.floor(Math.random() * RANDOM_CHARS.length));
    }
    return result;
};

/**
 * Sanitize a string into a URL-safe slug.
 * - Lowercases
 * - Replaces spaces/special chars with hyphens
 * - Removes consecutive hyphens
 * - Trims hyphens from edges
 * - Truncates to maxLength characters
 */
const slugify = (text, maxLength = 30) => {
    return (text || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')   // remove non-alphanumeric (except spaces & hyphens)
        .replace(/[\s-]+/g, '-')          // collapse whitespace/hyphens into single hyphen
        .replace(/^-+|-+$/g, '')          // trim leading/trailing hyphens
        .substring(0, maxLength);
};

/**
 * Generate a budget slug from a company name.
 * Returns something like "acme-corp-x7k2" or "retreat-a3m9" if no company name.
 */
export const generateBudgetSlug = (companyName) => {
    const base = slugify(companyName) || 'retreat';
    return `${base}-${randomSuffix()}`;
};
